import { SimpleGrid, Stack, Text } from '@mantine/core';
import { ReactNode } from 'react';
import { AppTooltip } from '../../../common/AppTooltip';

export interface MetricItem {
  label: string;
  labelTooltip?: string;
  value: ReactNode;
  sublabel?: ReactNode;
  /** Reserve a hidden goal sublabel line so adjacent cards align when only one tracks goals. */
  reserveGoalSublabel?: boolean;
}

export function MetricRow({ items }: { items: MetricItem[] }) {
  const cols = Math.max(1, Math.min(items.length, 4));

  return (
    <SimpleGrid
      cols={cols}
      spacing="md"
      breakpoints={[
        { maxWidth: 1200, cols: Math.min(3, cols) },
        { maxWidth: 900, cols: Math.min(2, cols) },
        { maxWidth: 520, cols: 1 },
      ]}
    >
      {items.map((item, idx) => (
        <Stack key={idx} spacing={2}>
          {item.labelTooltip ? (
            <AppTooltip label={item.labelTooltip} inline>
              <Text
                size="xs"
                color="dimmed"
                component="span"
                sx={{
                  cursor: 'help',
                  textDecoration: 'underline dotted',
                  textUnderlineOffset: 2,
                  display: 'inline-flex',
                  width: 'fit-content',
                }}
              >
                {item.label}
              </Text>
            </AppTooltip>
          ) : (
            <Text size="xs" color="dimmed">
              {item.label}
            </Text>
          )}
          <div>{item.value}</div>
          {item.sublabel || item.reserveGoalSublabel ? (
            <Stack spacing={0}>
              {item.sublabel ? (
                <Text size="xs" color="dimmed">
                  {item.sublabel}
                </Text>
              ) : item.reserveGoalSublabel ? (
                <Text size="xs" color="dimmed" sx={{ visibility: 'hidden' }} aria-hidden>
                  —
                </Text>
              ) : null}
              {item.reserveGoalSublabel ? (
                <Text size="xs" color="dimmed" sx={{ visibility: 'hidden' }} aria-hidden>
                  Goal —/year
                </Text>
              ) : null}
            </Stack>
          ) : null}
        </Stack>
      ))}
    </SimpleGrid>
  );
}
